import {
  CarePlanState,
  ADVANCED_PANEL_OPTION,
  LABS_ROW_KEY,
  applyPlaceItem,
  emptyState,
  ensurePsychiatricSupervision,
} from './carePlanState'

export const createIntakeCarePlan = (): CarePlanState => {
  let plan = ensurePsychiatricSupervision(emptyState())
  plan = applyPlaceItem(plan, LABS_ROW_KEY, 0, ADVANCED_PANEL_OPTION, 1)
  plan = applyPlaceItem(plan, 'modules.therapy', 1, 'Therapy', 3, 'therapy')
  plan = applyPlaceItem(plan, 'modules.coaching', 4, 'Coaching', 2, 'coaching')

  return { ...plan, expandedCategoryIds: ['modules', 'tracking'] }
}
